const EMPTY_VALUES = [undefined, null, ''];

export { EMPTY_VALUES as E };
